import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import avatarDefault from '../../images/user-default.png';

/**
 * This whole class is a little gross, but it tries to grab an image to show,
 * and starts by showing a placeholder until the real thing is ready. Designed
 * to work around the fact that thumbnails for new uploads might not yet be
 * generated by Lambda when we go to retrieve them.
 */
class AvatarImage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      source: avatarDefault,
      lastUpdateTimestamp: new Date(),
    };
  }

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isUpdatingUser && !this.props.isUpdatingUser) {
      this.getNewAvatarTimer = setTimeout(() => {
        this.setState({ lastUpdateTimestamp: new Date() }, () => {
          this.loadImage();
        });
      }, 1500);
    }
  }

  // TODO: Avoids memory leaks, but it would be better to refactor the whole server comms issue
  componentWillUnmount() {
    clearTimeout(this.getNewAvatarTimer);
    clearTimeout(this.reloadImageTimer);
  }

  loadImage = () => {
    const { avatarPath } = this.props;
    const { lastUpdateTimestamp } = this.state;

    const avatarUrl = `${avatarPath}?_ts=${lastUpdateTimestamp.getTime()}`;

    const ts = Date.now();
    const img = new Image();

    img.onerror = () => {
      if (Date.now() - ts < 10000) {
        this.reloadImageTimer = setTimeout(() => {
          img.src = avatarUrl;
        }, 1000);
      }
    };
    img.onload = () => {
      this.setState({ source: avatarUrl });
    };

    img.src = avatarUrl;
  };

  render() {
    return <img src={this.state.source} alt="Profile" className={this.props.className} />;
  }
}

AvatarImage.propTypes = {
  avatarPath: PropTypes.string.isRequired,
  isUpdatingUser: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

AvatarImage.defaultProps = {
  className: '',
};

function mapStateToProps(state) {
  const {
    auth: {
      user: { avatarPath },
      isUpdatingUser,
    },
  } = state;

  return {
    avatarPath,
    isUpdatingUser,
  };
}

export default connect(mapStateToProps)(AvatarImage);



// WEBPACK FOOTER //
// ./src/components/common/AvatarImage.jsx